module.exports = __webpack_public_path__ + "dd47e6c6ab912a14b0287c3844144ea3.svg";